const isMobile = window.matchMedia('(max-width: 767px)');
const isTablet = window.matchMedia('(min-width: 768px) and (max-width:992px)');

let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.cart-remove-button');
  if (!btn) return;

  e.preventDefault();
  btn.classList.add('loading');

  const variantId = btn.dataset.variantId;

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 0
    })
  })
  .then(res => res.text())
  .then(() => {
    refreshMiniCart()
  })
  .catch((e) => {
    console.error(e);
    btn.classList.remove('loading');
  });
});

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
    
    const variantId = this.input.dataset.quantityVariantId;
    const quantity = parseInt(this.input.value);

    fetch(`/cart/change.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
    .then(res => res.json())
    .then(cart => {
      // Publish an event so other quantity inputs update
      publish(PUB_SUB_EVENTS.quantityUpdate, { id: variantId, quantity });
      
      // Optional: refresh mini cart or drawer UI
      if (window.refreshMiniCart) refreshMiniCart(cart);
      this.querySelectorAll('button').forEach((btn) => btn.classList.remove('loading'));
    })
    .catch(err => {
      console.error(err);
      this.querySelectorAll('button').forEach((btn) => btn.classList.remove('loading'));
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    const btn = event.target.closest('button');
    btn.classList.add('loading');

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function discountApply(element){
  let applyDiscountBtn = element.querySelectorAll('.best-offer__apply');
  if(!applyDiscountBtn){
    return;
  }
  applyDiscountBtn.forEach(btn => {
    btn.addEventListener('click', function (e) {
    e.preventDefault();
    btn.classList.add('loading');
    let discountCodeURL = btn.getAttribute("href");
    if(!discountCodeURL || discountCodeURL ==  "#"){
      return;
    }
    fetch(discountCodeURL, {
      method: 'GET',
      credentials: 'include'
    })
    .then(() => {
      btn.classList.remove('loading');
      window.refreshMiniCart();
    })
    }
    )
  })
}
function initialProductsSlider(){
    let sliders = document.querySelectorAll("[data-splide-slider]");
    if(sliders.length<1){
        return;
    }
 
    sliders.forEach(slider_main => {
    let disableSliderInMobile = slider_main.getAttribute("data-disable-slider-in-mobile");
    
    if(disableSliderInMobile!=null && isMobile.matches){
        return;
    }

        let slider = slider_main.querySelector(".splide");
        let prev_button = slider_main.querySelector(".splide__arrow--prev");
        let next_button = slider_main.querySelector(".splide__arrow--next");
        var splide = new Splide( slider, {
        // focus    : 'center',
        loop: false,
        perPage: 4,
        drag: true,          // enable swipe/drag on touch devices
          flickPower: 100,     // sensitivity of swipe
          swipe: true,         // explicitly allow swipe
          touch: true,         // explicitly allow touch
         gap: '16px',
  breakpoints: {
    1024: {
      gap: '8px',
      perPage: 4,
    },
    640: {
        gap: '8px',
              autoWidth: true,
              focus:"center"
    },
  },
        } );
        var bar    = splide.root.querySelector( '.splide__progress__bar' );
  
  // Updates the bar width whenever the carousel moves:
  if(bar){
  splide.on( 'mounted move', function () {
    var end  = splide.Components.Controller.getEnd() + 1;
    var rate = Math.min( ( splide.index + 1 ) / end, 1 );
    bar.style.width = String( 100 * rate ) + '%';
  } );
  }
        splide.mount();

        prev_button.addEventListener("click",function(){
            slider.querySelector(".splide__arrow--prev").dispatchEvent(new Event("click"))
        })
        next_button.addEventListener("click",function(){
            slider.querySelector(".splide__arrow--next").dispatchEvent(new Event("click"))
        })
    });
}
function initialProductsVideoSlider(){
    let sliders = document.querySelectorAll("[data-splide-video]");
    if(sliders.length<1){
        return;
    }
 
    sliders.forEach(slider_main => {
    let disableSliderInMobile = slider_main.getAttribute("data-disable-slider-in-mobile");
    
    if(disableSliderInMobile!=null && isMobile.matches){
        return;
    }

        let slider = slider_main.querySelector(".splide");
        let prev_button = slider_main.querySelector(".splide__arrow--prev");
        let next_button = slider_main.querySelector(".splide__arrow--next");
        var splide = new Splide( slider, {
          loop: false,
          
          gap: '16px',
          breakpoints: {
            100000:{
  gap: '16px',
              perPage: 4,
            },
            1024: {
              gap: '16px',
              perPage: 4,
            },
            640: {
              gap: '8px',
              autoWidth: true,
              focus:"center"
            },
          },
          drag: true,          // enable swipe/drag on touch devices
          flickPower: 100,     // sensitivity of swipe
          swipe: true,         // explicitly allow swipe
          touch: true,         // explicitly allow touch
        });

        splide.mount();

        prev_button.addEventListener("click",function(){
            slider.querySelector(".splide__arrow--prev").dispatchEvent(new Event("click"))
        })
        next_button.addEventListener("click",function(){
            slider.querySelector(".splide__arrow--next").dispatchEvent(new Event("click"))
        })
    });
}

function productJsonHtml(product) {
  const {
    id,
    handle,
    title,
    variants,
    images,
    compare_at_price_max,
    price
  } = product;

  const firstVariant = variants?.[0];
  const variantId = firstVariant?.id || '';

  // Use first two images if available
  const img1 = images?.[0];
  const img2 = images?.[1];

  const hasCompare = firstVariant?.compare_at_price && firstVariant.compare_at_price !== firstVariant.price;
  const discount = hasCompare
    ? Math.round(((parseFloat(firstVariant.compare_at_price) - parseFloat(firstVariant.price)) / parseFloat(firstVariant.compare_at_price)) * 100)
    : 0;

  const displayPrice = firstVariant?.price || price;
  const displayCompare = firstVariant?.compare_at_price || compare_at_price_max;

  return `
<article class="product-card" data-product-id="${id}">
  <a href="/products/${handle}" class="product--link"></a>
  <div class="product-card__media">
    <div class="img-wrapper js-lazy">
      <div class="skeleton"></div>
      ${
        img1
          ? `<picture>
        <source media="(max-width: 749px)" data-srcset="${img1.src}&width=400">
        <source media="(min-width: 750px)" data-srcset="${img1.src}&width=600">
        <img data-src="${img1.src}&width=600" loading="lazy" alt="${title}">
      </picture>`
          : ''
      }
      ${
        img2
          ? `<picture>
        <source media="(max-width: 749px)" data-srcset="${img2.src}&width=400">
        <source media="(min-width: 750px)" data-srcset="${img2.src}&width=600">
        <img class="second-image" data-src="${img2.src}&width=600" loading="lazy" alt="${title}">
      </picture>`
          : ''
      }
    </div>
  </div>

  <div class="product-card__meta">
    <div class="product-top">
      <span class="product-size">30 ml</span>
    </div>

    <h3 class="product-title">
      <a href="/products/${handle}">${title}</a>
    </h3>

    <div class="product-price">
      <strong>Rs. ${parseFloat(displayPrice).toFixed(2)}</strong>
      ${hasCompare ? `<del>Rs. ${parseFloat(displayCompare).toFixed(2)}</del><span class="product-off">${discount}% OFF</span>` : ''}
    </div>
  </div>
<product-form class="product-form">
  <form action="/cart/add" method="post" >
    <input type="hidden" name="id" value="${variantId}">
    <button type="submit" name="add" class="btn product-btn">
      <span>Add to cart</span>
      <div class="loading__spinner hidden"><svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg></div>
    </button>
  </form>
  </product-form>
</article>
  `.trim();
}

function filterByTag() {
    const collections = document.querySelectorAll(".featured-collection.with__filters");
    if (!collections.length) return;
    
    collections.forEach(section => {
        const disableSliderInMobile = section.getAttribute("data-disable-slider-in-mobile");
        const isSliderDisabled = disableSliderInMobile !== null && isMobile.matches;

        const sliderEl = section.querySelector(".splide");
        const prevBtn = section.querySelector(".splide__arrow--prev");
        const nextBtn = section.querySelector(".splide__arrow--next");
        const collection_url = section.getAttribute("data-collection-url");

        let all_products = [];
        let splide = null;

        fetch(collection_url)
        .then(r => r.json())
        .then(data => {
            all_products = data.products;
        });

        const config = {
            autoWidth: false,
            perPage: 4,
            gap: "16px",
            breakpoints: {
                1024: { gap: "16px", perPage: 4 },
                640: { gap: "8px", perPage: 2 },
            },
        };

        // ✅ Only initialize Splide if NOT disabled on mobile
        if (!isSliderDisabled && sliderEl) {
            splide = new Splide(sliderEl, config);
            splide.mount();

            prevBtn?.addEventListener("click", () => splide.go("<"));
            nextBtn?.addEventListener("click", () => splide.go(">"));
        }

        const tags = section.querySelectorAll(".concern-tag");
        if (!tags.length) return;

        tags.forEach((tag,index) => {
            tag.addEventListener("click", e => {
                e.preventDefault();

                const tag_name = tag.getAttribute("data-tag");
                if (!tag_name) return;

                let newHtml = '';
                if(index != 0)
                {
                  let filtered = all_products.filter(p => p.tags.includes(tag_name));

                filtered.forEach(product => {
                    let product_html = productJsonHtml(product);
                    newHtml += '<li class="splide__slide">';
                    newHtml += product_html;
                    newHtml += "</li>";
                });
                }
                else{
                  // let filtered = all_products.filter(p => p.tags.includes(tag_name));

                all_products.forEach(product => {
                    let product_html = productJsonHtml(product);
                    newHtml += '<li class="splide__slide">';
                    newHtml += product_html;
                    newHtml += "</li>";
                });
                }

                if (!newHtml) return;

                // ✅ If slider enabled → destroy + rebuild
                if (splide) {
                    splide.destroy();
                }

                sliderEl.querySelector(".splide__list").innerHTML = newHtml;

                // ✅ Rebuild only if slider should exist
                if (!isSliderDisabled) {
                    splide = new Splide(sliderEl, config);
                    splide.mount();
                }

                lazyLoadImages(sliderEl);
                productForm(sliderEl);
                tags.forEach(t => t.classList.remove("is-active"));
                tag.classList.add("is-active");
            });
        });
    });
}

function lazyLoadImages(selector = document) {
  if (!selector) return;

  const wrappers = selector.querySelectorAll('.js-lazy:not(.lazy-processed)');
  if (!wrappers.length) return;

  const supportsObserver = 'IntersectionObserver' in window;

  const retryCount = 2;
  const retryDelay = 400;

  const applySources = (picture) => {
    const sources = picture.querySelectorAll('source[data-srcset]');
    sources.forEach(source => {
      source.srcset = source.dataset.srcset;
      source.removeAttribute('data-srcset');
    });
  };

  const loadImage = (img) => {
    return new Promise((resolve, reject) => {
      if (img.dataset.src) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      }

      if (img.complete && img.naturalWidth !== 0) {
        resolve();
        return;
      }

      img.onload = () => {
        img.naturalWidth === 0 ? reject() : resolve();
      };

      img.onerror = reject;
    });
  };

  const retryable = (img, attempt = 0) => {
    return loadImage(img).catch(() => {
      if (attempt < retryCount) {
        return new Promise(res =>
          setTimeout(() => res(retryable(img, attempt + 1)), retryDelay)
        );
      }
      return Promise.reject();
    });
  };

  const markLoaded = (wrapper) => {
    wrapper.classList.add('loaded');
    wrapper.classList.remove('loading');

    const skeleton = wrapper.querySelector('.skeleton');
    // if (skeleton) skeleton.remove();
  };

  const markError = (wrapper) => {
    wrapper.classList.add('error');
  };

  const processWrapper = (wrapper) => {
    wrapper.classList.add('lazy-processed');
    wrapper.classList.add('loading');

    const pictures = wrapper.querySelectorAll('picture');
    pictures.forEach(picture => applySources(picture));

    const images = wrapper.querySelectorAll('img');

    const loaders = [...images].map(img => retryable(img));

    Promise.allSettled(loaders).then(results => {
      const hasError = results.some(r => r.status === 'rejected');

      if (hasError) {
        markError(wrapper);
      } else {
        markLoaded(wrapper);
      }
    });
  };

  if (!supportsObserver) {
    wrappers.forEach(processWrapper);
    return;
  }

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      processWrapper(entry.target);
      obs.unobserve(entry.target);
    });
  }, {
    rootMargin: '250px 0px', // good for ecommerce grids
    threshold: 0.01
  });

  wrappers.forEach(wrapper => observer.observe(wrapper));
}



// Bunde code
let products_in_bundle = [];
const bundleItems = document.querySelectorAll(".bundle-builder .bundle-item");
function resetBundle(products_in_bundle, bundleItems) {
  products_in_bundle.length = 0;

  bundleItems.forEach(item => {
    const img = item.querySelector("img");
    const text = item.querySelector("p");

    if (img) img.src = ""; // or placeholder URL
    item.classList.remove("is-filled");
    item.classList.add("is-empty");

    if (text) text.style.display = "block";
  });

  document.querySelectorAll(".add-to-bundle").forEach(btn => {
    btn.classList.remove("active");
  });

  const bundleAddBtn = document.querySelector(".bundle-right .btn");
  bundleAddBtn.classList.remove("active", "loading");
}
function updateBundleUI(products, bundleItems) {
  bundleItems.forEach((item, index) => {
    const img = item.querySelector(".bundle--img");
    const text = item.querySelector("p");
    
    if (products[index]) {
      // FILL SLOT
      
      if (img) {
        img.src = products[index].image;
      }
      console.log(img)
      item.classList.remove("is-empty");
      item.classList.add("is-filled");

      if (text) text.style.display = "none";
    } else {
      // EMPTY SLOT
      if (img) {
        img.src = ""; // or keep existing placeholder
      }

      item.classList.remove("is-filled");
      item.classList.add("is-empty");

      if (text) text.style.display = "block";
    }
  });
  if(products.length >= bundle_maximum_products)
  {
    document.querySelector(".bundle-right .btn").classList.add("active")
    
  }
  else{
    document.querySelector(".bundle-right .btn").classList.remove("active")
    
  }
}
function addBundleToCart(products) {
  if (!products.length) return;
  const items = products.map(product => ({
    id: product.id,
    quantity: 1,
    properties: {
      _bundle: "true"
    }
  }));
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ items })
  })
  .then(res => res.json())
  .then(data => {
    document.querySelector(".bundle-right .btn").classList.remove("loading")
    resetBundle(products_in_bundle,bundleItems)
    updateBundlePrice([]);
    window.refreshMiniCart();
    openCart();
  })
  .catch(err => {
    console.error("Add bundle error", err);
    document.querySelector(".bundle-right .btn").classList.remove("loading")
  });
}
function formatMoney(amount) {
  return "₹ " + (amount / 100).toLocaleString("en-IN");
}

function updateBundlePrice(products) {
  let totalOriginal = 0;
  let totalDiscounted = 0;

  products.forEach(product => {
    totalOriginal += product.price;

    if (product.discount) {
      const discounted = product.price - (product.price * product.discount / 100);
      totalDiscounted += discounted;
    } else {
      totalDiscounted += product.price;
    }
  });

  const priceEl = document.querySelector(".bundle-right .price");
  const oldPriceEl = document.querySelector(".bundle-right .price-old");

  priceEl.textContent = formatMoney(totalDiscounted);
  oldPriceEl.textContent = formatMoney(totalOriginal);
}

function productBundle() {
  if (document.querySelectorAll(".all-bundle").length < 1) return;

  const buttons = document.querySelectorAll(".add-to-bundle");
  
  

  buttons.forEach(btn => {
    btn.addEventListener("click", () => {
      const id = btn.dataset.productId;
      const image = btn.dataset.productImage;
       const price = parseInt(btn.dataset.productPrice);
      const discount = parseInt(btn.dataset.productDiscount);

      const index = products_in_bundle.findIndex(p => p.id === id);

      if (index !== -1) {
        // REMOVE
        products_in_bundle.splice(index, 1);
        btn.classList.remove("active");
      } else {
        // ADD (only if under max)
        if (products_in_bundle.length < bundle_maximum_products) {
          products_in_bundle.push({ id, image, price, discount });
          btn.classList.add("active");
        } else {
          return;
        }
      }
      updateBundleUI(products_in_bundle, bundleItems);
      updateBundlePrice(products_in_bundle);
     
    
    });
  });
  
   const bundleAddBtn = document.querySelector(".bundle-right .btn");
      bundleAddBtn.addEventListener("click", () => {
      if (!bundleAddBtn.classList.contains("active")) return;
      bundleAddBtn.classList.add("loading")
      addBundleToCart(products_in_bundle);
      
    });

    document.querySelectorAll(".bundle-item .item-check").forEach(check => {
  check.addEventListener("click", (e) => {
    const bundleItem = e.target.closest(".bundle-item");
    const index = parseInt(bundleItem.dataset.index);

    const removedProduct = products_in_bundle[index];

    if (!removedProduct) return;

    // Remove from array
    products_in_bundle.splice(index, 1);

    // Remove active state from original add button
    document.querySelectorAll(".add-to-bundle").forEach(btn => {
      if (btn.dataset.productId === removedProduct.id) {
        btn.classList.remove("active");
      }
    });

    updateBundleUI(products_in_bundle, bundleItems);
    updateBundlePrice(products_in_bundle);
  });
});

}


function allPoductsFilter(){
  let filters_wrapper = document.querySelector(".collection-header__filters");
  if(!filters_wrapper) return;
  let all_filter_btn = filters_wrapper.querySelectorAll(".filter-tag");
  if(!all_filter_btn) return;
  all_filter_btn.forEach(btn => {
    btn.addEventListener("click",function(){
      btn.classList.add("loading");
      let slug = this.dataset.slug;
      fetch(`/collections/${slug}/`)
        .then(r => r.text())
        .then(data => {
          history.pushState({}, "", `/collections/${slug}`);
              const parser = new DOMParser();
              const doc = parser.parseFromString(data, "text/html");
              const collectionProducts = doc.querySelector(".collection-products-all");
              const collectionProductsHeader = doc.querySelector(".collection-header__top");
          document.querySelector(".collection-products-all").innerHTML = collectionProducts.innerHTML;
          document.querySelector(".collection-header__top").innerHTML = collectionProductsHeader.innerHTML;
          lazyLoadImages(document.querySelector(".collection-products-all"));
          productForm(document.querySelector(".collection-products-all"));
          btn.classList.remove("loading");
           const sortBtn = document.querySelector(".sort-btn");
        if (sortBtn) {
          sortBtn.value = "default";
        }
        })
      
      
      filters_wrapper.querySelectorAll(".filter-tag").forEach(btn => {
        btn.classList.remove("is-active");
      });
      this.classList.add("is-active");
    })
  })

  const sortBtn = document.querySelector(".sort-btn");
  if (!sortBtn) return;
const params = new URLSearchParams(window.location.search);
const sortValue = params.get("sort_by");

if (sortValue) {
  sortBtn.value = sortValue;
}
  sortBtn.addEventListener("change", function () {
    const value = this.value;
    if (!value) return;                       // ignore empty selection
    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", value);   // replaces or adds param
    url.searchParams.set("page", 1);   // replaces or adds param
    fetch(url.toString())
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newGrid = doc.querySelector(".collection-products-all");
        if (newGrid) {
          document.querySelector(".collection-products-all").innerHTML = newGrid.innerHTML;
          lazyLoadImages(document.querySelector(".collection-products-all"));
          
        }
        history.pushState({}, "", url);       // update address bar last
            // sortBtn.value = "default";
      });
  });
}


function pagination(){
  let pagination = document.querySelector(".collection-pagination");
  if(!pagination) return;
    pagination.querySelectorAll("a").forEach(btn => {
      btn.addEventListener("click",function(e){
        e.preventDefault();
        let url = this.href;
        fetch(url)
        .then(r => r.text())
        .then(data => {
          history.pushState({}, "", url);
              const parser = new DOMParser();
              const doc = parser.parseFromString(data, "text/html");
              const collectionProducts = doc.querySelector(".collection-products-all");
          document.querySelector(".collection-products-all").innerHTML = collectionProducts.innerHTML;
          lazyLoadImages(document.querySelector(".collection-products-all"));
        })
      })
    })
}

function initSplideSliders(element){
  let all_sliders = element.querySelectorAll("[data-splide]");
  if(!all_sliders) return;
  all_sliders.forEach(slider => {
    if(slider.classList.contains("is-initialized")) return;
    new Splide(slider, slider.dataset.splide).mount();
  })
}
function cartToggle(){
  let cartBtn = document.querySelector(".site-header .cart");
  if(!cartBtn) return;
  cartBtn.addEventListener("click",function(){
    document.querySelector(".cart-sidebar-main").classList.toggle("active");
  })
  let cartCloseBtn = document.querySelector(".cart-sidebar .cart-header .cart-close");
  let cartOverlay = document.querySelector(".cart-sidebar-main .overlay");
  if(!cartCloseBtn) return;
  cartCloseBtn.addEventListener("click",function(){
    document.querySelector(".cart-sidebar-main").classList.remove("active");
  })
  cartOverlay.addEventListener("click",function(){
    document.querySelector(".cart-sidebar-main").classList.remove("active");
  })
}
window.refreshMiniCart = function(){
  fetch(routes.cart_url+"?section_id=cart-sidebar")
  .then(r => r.text())
  .then(data => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(data, "text/html");
    const cartSidebar = doc.querySelector(".cart-sidebar-main");
    const mainCart = document.querySelector(".cart-sidebar-main");
    if (doc) {
      mainCart.querySelector(".cart-title").innerHTML = cartSidebar.querySelector(".cart-title").innerHTML;
      const cartItems = cartSidebar.querySelector(".cart-items");
      const cartSummary = cartSidebar.querySelector(".cart-summary");
      const cartCount = cartSidebar.querySelector(".cart-item-count");
      const cartRecommendationInner = cartSidebar.querySelector(".cart--recommendation__inner");
      const bestOffer = cartSidebar.querySelector(".best-offer");
      const cartOffer = cartSidebar.querySelector(".cart-offer");
      const bundleCard = cartSidebar.querySelector(".bundle-card");
      const cart_section = document.querySelector(".cart-section");
      mainCart.querySelector(".cart-items").innerHTML = cartItems.innerHTML;
      mainCart.querySelector(".cart-summary").innerHTML = cartSummary.innerHTML;
      document.querySelector(".site-header .cart-count").innerHTML = cartCount.innerHTML;
      if(cartCount.innerHTML =="0")
      {
        document.body.classList.add("is-empty-cart");
        document.querySelector(".site-header .cart-count").innerHTML = "";
      }
      else {
        document.body.classList.remove("is-empty-cart");
      }
      
      if(bestOffer) {
        mainCart.querySelector(".best-offer").innerHTML = bestOffer.innerHTML;
        discountApply(mainCart);
      }
      if(cartRecommendationInner) {
        mainCart.querySelector(".cart--recommendation__inner").innerHTML = cartRecommendationInner.innerHTML;
      }
      if(mainCart.querySelector(".cart-offer"))
      {
        if(mainCart) {
        mainCart.querySelector(".cart-offer").classList.remove("hidden");
        if(cartOffer && mainCart.querySelector(".cart-offer")){
mainCart.querySelector(".cart-offer").innerHTML = cartOffer.innerHTML;
        }

      }
      else {
        mainCart.querySelector(".cart-offer").classList.add("hidden");
      }
      }
      if(bundleCard && mainCart.querySelector(".bundle-card")) {
        mainCart.querySelector(".bundle-card").innerHTML = bundleCard.innerHTML;
      }
      if(cart_section){
        cart_section.querySelector(".cart-items").innerHTML = cartItems.innerHTML;
        cart_section.querySelector(".cart-summary").innerHTML = cartSummary.innerHTML;
      }
      initSplideSliders(mainCart);
      productForm(mainCart);
      
    }
  })
}

function closeCart(){
 if(!document.querySelector(".cart-sidebar-main")) return;
 document.querySelector(".cart-sidebar-main").classList.remove("active");
}

function openCart(){
 if(!document.querySelector(".cart-sidebar-main")) return;
 document.querySelector(".cart-sidebar-main").classList.add("active");
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      Accept: `application/${type}`,
    },
    credentials: 'same-origin',
  };
}
function shopifyJSONRoute(route) {
  return `${route}.js`;
}
function productForm(element) {
  const all_product_forms = element.querySelectorAll('.product-form form');
  if (!all_product_forms.length) return;

  all_product_forms.forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();

      const submitButton = form.querySelector('[type="submit"]');
      submitButton.classList.add('loading');

      const config = fetchConfig('json');
      config.body = new FormData(form);
      fetch(shopifyJSONRoute(routes.cart_add_url), config)
        .then(res => res.json())
        .then(response => {
          if (response.status === 422) {
            console.error(response.description);
            return;
          }

          
        })
        .catch(console.error)
        .finally(() => {
          submitButton.classList.remove('loading');
          window.refreshMiniCart();
          openCart();
        });
    });
  });
}

function accordion(){
  const faqGroups = document.querySelectorAll('[data-accordion-group]');
  faqGroups.forEach(group => {
    let mobileOnly = false;
    if(group.dataset.accordionMobileOnly) {
      mobileOnly = true;
    }
    if(mobileOnly && !isMobile()) {
      return;
    }
    let openFirst = group.hasAttribute("data-accordion-open-first");
    const faqItems = group.querySelectorAll('[data-accordion-item]');
    // if(openFirst != null && faqItems[0])
    // {
    //   faqItems[0].classList.add("is-open")
    // }
    faqItems.forEach(item => {
      const btn = item.querySelector('[data-accordion-button]');
      const answer = item.querySelector('[data-accordion-content]');
      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');
        faqItems.forEach(i => {
          i.classList.remove('is-open');
        });
        if (!isOpen) {
          item.classList.add('is-open');
        }
      });
    });
  });
}
function productGallery(){
  let productGallery = document.querySelector(".pdp-gallery");
  if(!productGallery) return;
  if (!isMobile.matches && !isTablet.matches) {
  return;
}
     var splide = new Splide( productGallery, {
        
        loop: false,
        autoWidth: false,
        perPage: 1,
         gap: '16px',
  breakpoints: {
    1024: {
      gap: '16px',
      perPage: 1,
    },
    992: {
      gap: '8px',
      perPage: 2,
    },
    640: {
      gap: '8px',
      perPage: 1,
      focus    : 'center',
    },
  },
        } );

        splide.mount();
}
function playPauseVideos(){
    let all_videos = document.querySelectorAll(".c-video");
    if(all_videos.length<1) return;
    all_videos.forEach(video_container => {
        let btn = video_container.querySelector(".play-btn");
        let video = video_container.querySelector("video")
        let status = false;
        btn.addEventListener("click",function(){
            status = !status;
            if(status){
                video.play();
                video.muted = false;
                video_container.classList.add("active");
            }
            else
            {
                video.pause();
                video.muted = true;
                video_container.classList.remove("active");
            }
        })
    });
}
function stickyAddToCart(){
  if(document.querySelector(".product-form-sticky") && isMobile.matches){
    let sticky = document.querySelector(".product-form-sticky");
    let lastScrollY = window.scrollY;
    window.addEventListener("scroll", function(){
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 300) {
        sticky.classList.add("is-sticky-show");
      } else {
        sticky.classList.remove("is-sticky-show");
      }
      lastScrollY = currentScrollY;
    });
  }
}
document.addEventListener("DOMContentLoaded",function(){
    initialProductsSlider();
    filterByTag();
    lazyLoadImages(document);
    productBundle();
    allPoductsFilter();
    initSplideSliders(document);
    cartToggle();
    productForm(document);
    discountApply(document);
    accordion();
  productGallery();
  initialProductsVideoSlider();
  playPauseVideos();
  stickyAddToCart();
    const cartCount = document.querySelector(".cart-item-count");
     if(cartCount.innerHTML =="0")
      {
        document.body.classList.add("is-empty-cart");
      }
      else {
        document.body.classList.remove("is-empty-cart");
      }
})
  